import { render, staticRenderFns } from "./SpellingBeeLanding.vue?vue&type=template&id=deb018a4&scoped=true"
import script from "./SpellingBeeLanding.js?vue&type=script&lang=js&external"
export * from "./SpellingBeeLanding.js?vue&type=script&lang=js&external"
import style0 from "./SpellingBeeLanding.scss?vue&type=style&index=0&id=deb018a4&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deb018a4",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LoadingSpinner: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/common/LoadingSpinner.vue').default,WfChip: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/common/WfChip.vue').default,Advertisement: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/Advertisement/Advertisement.vue').default,TheSidebar: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/template/TheSidebar.vue').default})
